import type { Environment } from '@change-corgi/core/environment';

export const typesenseConfig: Record<Environment, { host: string; apiKey: string }> = {
	staging: {
		host: 'www.staging-change.org',
		apiKey: '7CQBIEN1kUwxMhPnvrWrTnChc5Ts9pZA',
	},
	production: {
		host: 'www.change.org',
		apiKey: 'xyz',
	},
	demo: {
		host: 'www.staging-change.org',
		apiKey: '7CQBIEN1kUwxMhPnvrWrTnChc5Ts9pZA',
	},
	development: {
		host: 'www.staging-change.org',
		apiKey: '7CQBIEN1kUwxMhPnvrWrTnChc5Ts9pZA',
	},
};
